import {Dispatch, SetStateAction} from "react";
import {MobileView} from "react-device-detect";
import {Nav} from "react-bootstrap";
import {usePwa} from "@dotmind/react-use-pwa";

export const InstallPwa
    : React.FC<{setExpanded: Dispatch<SetStateAction<boolean>>}>
    = (props) => {

    const { setExpanded } = props

    const {
        isInstalled,
        installPrompt,
        canInstall
    } = usePwa();

    return (
        <>
            <MobileView>
                {canInstall && !isInstalled ?
                    <Nav.Link onClick={() => {installPrompt().then(r => setExpanded(false)) }
                    }>Zainstaluj na ekranie głównym</Nav.Link>
                    :
                    <></>}
            </MobileView>
        </>
    )
}